import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import {
  Button,
  CustomInput,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import Select from 'react-select';
import 'react-quill/dist/quill.snow.css';
import {
  gAPI_Users_By_Id,
  gAPI_Property_List_By_Group,
  API_FAQ,
} from '../../../../../constants/APIs';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
const quillModules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];

function FAQForm({
  id,
  faqCollectionList,
  submit,
  visible,
  label,
  toggle,
  propertyId,
  locale,
}) {
  const [open, setOpen] = useState(false);
  const [property, setProperty] = useState([
    { label: 'All', value: 'All', key: 'All' },
  ]);
  const [selectedProperty, setSelectedProperty] = useState([]);
  const [msg, setMsg] = useState([]);
  const [faqData, setFAQData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    question: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    collection: '',
    displayOrder: 0,
    status: 'Draft',
    answer: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    properties: [],
    locale: locale,
    internalCopilot: false,
    creator: 'Admin',
  });

  useEffect(() => {
    let faqProperties = [];
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
      }).then((result) => {
        AxiosAPI({
          method: 'get',
          url: `${API_FAQ}/${id}`,
        }).then((res) => {
          if (res.data !== undefined && res.data.id !== undefined) {
            faqProperties = res.data.properties;
            setFAQData({
              ...faqData,
              question: res.data.question,
              answer: res.data.answer,
              collection: res.data.collection,
              displayOrder: res.data.displayOrder,
              status: res.data.status,
              userName: result.data.fullName,
              internalCopilot: res.data.internalCopilot,
              properties: res.data.properties,
            });
            AxiosAPI({
              method: 'get',
              url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
            })
              .then((res) => {
                if (res.data !== undefined && res.data.length > 0) {
                  let lst = [{ id: 'All', name: 'All' }];
                  res.data.map((m) => lst.push({ id: m.id, name: m.name }));
                  setProperty(lst);

                  if (faqProperties !== undefined && faqProperties.length > 0) {
                    let selectedList = [];
                    console.log('faqProperties', faqProperties);
                    if (faqProperties.length === res.data.length)
                      setSelectedProperty({
                        label: 'All',
                        value: 'All',
                        key: 'All',
                      });
                    else {
                      faqProperties.map((m) => {
                        if (res.data.filter((f) => f.id === m).length > 0)
                          selectedList.push({
                            key: res.data.filter((f) => f.id === m)[0].id,
                            label: res.data.filter((f) => f.id === m)[0].name,
                            value: res.data.filter((f) => f.id === m)[0].id,
                          });
                      });
                      setSelectedProperty(selectedList);
                    }
                  }
                }
              })
              .catch((err) => console.error(err));
          }
        });
      });
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
      }).then((res) => {
        setFAQData({ ...faqData, userName: res.data.fullName });
      });
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          if (res.data !== undefined && res.data.length > 0) {
            let lst = [{ id: 'All', name: 'All' }];
            res.data.map((m) => lst.push({ id: m.id, name: m.name }));
            setProperty(lst);
          }
        })
        .catch((err) => console.error(err));
    }
  }, [id]);

  const handleSave = () => {
    submit(faqData);
    //();
  };

  const handleCollection = (e) => {
    setFAQData({ ...faqData, collection: e.target.value });
  };

  const handleChecked = (e) => {
    setFAQData({ ...faqData, internalCopilot: e.target.checked });
  };

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };

  const handleChangeAnswer = (source, e) => {
    if (source === 'user') {
      if (faqData.answer.length > 0) {
        const index = faqData.answer.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setFAQData({
            ...faqData,
            answer: [...faqData.answer, newStatement],
          });
        } else {
          let newArr = [...faqData.answer];
          newArr[index].statement = e;
          setFAQData({
            ...faqData,
            answer: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setFAQData({
          ...faqData,
          answer: [...faqData.answer, newStatement],
        });
      }
    }
  };

  const handleChangeQuestion = (e) => {
    if (faqData.question.length > 0) {
      const index = faqData.question.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setFAQData({
          ...faqData,
          question: [...faqData.question, newStatement],
        });
      } else {
        let newArr = [...faqData.question];
        newArr[index].statement = e.target.value;
        console.log(newArr);
        setFAQData({
          ...faqData,
          question: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setFAQData({
        ...faqData,
        question: [...faqData.question, newStatement],
      });
    }
  };

  const handleFAQBusiness = (options) => {
    setSelectedProperty(options);
    if (options.filter((f) => f.value === 'All').length === 0) {
      setFAQData({ ...faqData, properties: options.map((i) => i.value) });
    } else {
      setFAQData({
        ...faqData,
        properties: property.filter((f) => f.id !== 'All').map((i) => i.id),
      });
    }
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
        <ModalHeader toggle={toggle}>{label}</ModalHeader>
        <ModalBody>
          <Row>
            <Colxx sm={12} className="mb-3">
              <Label>
                Question<span style={{ color: 'red' }}> *</span>
              </Label>
              <Input
                type="textarea"
                value={getLocalStatement(faqData.question)}
                onChange={handleChangeQuestion}
                name="question"
                style={{ height: '50px' }}
              />
            </Colxx>
            <Colxx sm={12} className="mb-3">
              <Label>
                Answer<span style={{ color: 'red' }}> *</span>
              </Label>
              <ReactQuill
                theme="snow"
                value={getLocalStatement(faqData.answer)}
                onChange={(content, delta, source) =>
                  handleChangeAnswer(source, content)
                }
                modules={quillModules}
                formats={quillFormats}
                name="answer"
              />
            </Colxx>
            {faqCollectionList !== undefined &&
              faqCollectionList.length > 0 && (
                <Colxx sm={4} className="mb-3">
                  <Label>
                    Collection<span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={faqData.collection}
                    name="status"
                    onChange={handleCollection}
                  >
                    <option value={''}>Please Select</option>
                    {faqCollectionList.map((m) => (
                      <option value={m.id}>{m.title}</option>
                    ))}
                  </Input>
                </Colxx>
              )}
            <Colxx sm={4} className="mb-3">
              <Label>Display Order</Label>
              <Input
                type="number"
                min={0}
                name="displayOrder"
                value={faqData.displayOrder}
                onChange={(e) =>
                  setFAQData({ ...faqData, displayOrder: e.target.value })
                }
              />
            </Colxx>
            <Colxx sm={4} className="mb-3">
              <Label>Internal Copilot Only</Label>
              <CustomInput
                type="checkbox"
                min={0}
                name="internalCopilot"
                checked={faqData.internalCopilot ? true : false}
                onChange={handleChecked}
              />
            </Colxx>
            <Colxx sm={4} className="mb-3">
              <Label>
                Status<span style={{ color: 'red' }}> *</span>
              </Label>
              <Input
                type="select"
                value={faqData.status}
                name="status"
                onChange={(e) =>
                  setFAQData({ ...faqData, status: e.target.value })
                }
              >
                <option value="Draft">Draft</option>
                <option value="ReadyToPublish">Ready to publish</option>
                {/* <option value="Published">Published</option> */}
              </Input>
            </Colxx>
            <Colxx sm={6} className="mb-3">
              <Label>Other Applicable Businesses</Label>
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                isMulti={true}
                name="form-field-name"
                options={
                  property.length > 0 &&
                  property
                    .filter((f) => f.id !== propertyId)
                    .map((x, i) => {
                      return { label: x.name, value: x.id, key: i };
                    })
                }
                value={selectedProperty}
                onChange={(val) => {
                  handleFAQBusiness(val);
                }}
              />
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSave}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Back
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(FAQForm));
